const TripHeader = ({ title }) => 
    <div className="trip-details-header">
    <h1>{title}</h1>
    </div>;
export default TripHeader;
